import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import FingoLink from '../links/FingoLink';
import LightningFastPayment from '../tooltips/LightningFastPayment';
import { cutText } from '../../helpers/text-parser';
import { InvoiceType } from '../../propTypes';
import { DEFAULT_LINK_CLASS_NAME } from '../../theme/constants/link';
import { FAST_PAYMENT_APROVED_STATES } from '../../constants/cache-constants';

const MAX_FOLIO_LENGTH = 8;

const FolioCell = ({ invoice, alignCenter, maxLength }) => {
  const { id, folio, lightningPaymentState } = invoice;
  const hasLightningPayment = FAST_PAYMENT_APROVED_STATES.includes(lightningPaymentState);
  const alignItemsCenter = alignCenter || hasLightningPayment;

  return (
    <Box sx={{
      display: 'flex',
      alignItems: alignItemsCenter ? 'center' : 'flex-start',
      justifyContent: alignCenter ? 'center' : 'flex-start',
      width: alignCenter ? '100%' : 'auto',
      height: alignCenter ? '100%' : 'auto',
    }}
    >
      <Tooltip title={folio.length > maxLength ? folio : ''} placement="top">
        <FingoLink
          id="invoice-profile"
          to={{
            pathname: '/app/invoice',
            search: `?invoiceId=${id}`,
          }}
          size="small"
          className={DEFAULT_LINK_CLASS_NAME}
          variant="text"
          sx={{
            px: { xs: 0, md: 0 },
            py: 0,
            minWidth: { xs: 0, md: 64 },
          }}
        >
          <Typography
            sx={{
              maxHeight: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            variant="body2"
            align={alignCenter ? 'center' : 'left'}
          >
            {cutText(folio, maxLength, 0)}
          </Typography>
        </FingoLink>
      </Tooltip>
      {hasLightningPayment && <LightningFastPayment invoice={invoice} iconSize={32} />}
    </Box>
  );
};

FolioCell.propTypes = {
  invoice: InvoiceType.isRequired,
  alignCenter: PropTypes.bool,
  maxLength: PropTypes.number,
};

FolioCell.defaultProps = {
  alignCenter: false,
  maxLength: MAX_FOLIO_LENGTH,
};

export default FolioCell;
